
export function CoursesSection() {
  const courses = [
    {
      title: 'Estrategias Publicitarias Avanzadas',
      badge: 'Facebook Ads',
      image: 'https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/5b48623fddede62d80f792b21cc2f915.jpeg',
    },
    {
      title: 'Venta por WhatsApp',
      badge: 'Conversión',
      image: 'https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/35e796b5b6727cd830e10b20f159531c.jpeg',
    },
    {
      title: 'Embudos y VSL y Páginas de Alta Conversión',
      badge: 'Funnels',
      image: 'https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/95c097ee04be1553a1ddc69469677698.jpeg',
    },
    {
      title: 'Clases en VIVO',
      badge: 'Exclusivo',
      image: 'https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/9fc0135a95f2545edfcc07ab4d96091f.jpeg',
      isDark: true,
    },
    {
      title: 'Comunidad Privada',
      badge: 'Soporte 24/7',
      image: 'https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/ce2ff3d164cf4b73b18d219ecc44858b.jpeg',
    },
  ];

  const benefits = [
    { icon: 'ri-refresh-line', text: 'Actualizaciones constantes' },
    { icon: 'ri-tools-line', text: 'Acceso de inmediato y de por Vida' },
    { icon: 'ri-medal-line', text: 'Soporte de por vida por nuestra comunidad en skool y telegram' },
  ];

  return (
    <section id="cursos" className="py-12 sm:py-16 lg:py-24 bg-gradient-to-br from-slate-50 via-purple-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16 space-y-3 sm:space-y-4">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900">Qué incluye tu acceso</h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed">
            Acceso completo a todos los cursos y soporte que necesitas para comenzar a vender desde el primer día
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {courses.map((course, index) => (
            <div
              key={index}
              className={`group rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer ${
                course.isDark ? 'bg-gradient-to-br from-gray-900 to-slate-800' : 'bg-white'
              }`}
            >
              <div className="relative h-40 sm:h-44 lg:h-48 overflow-hidden">
                <img
                  alt={course.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src={course.image}
                />
                <div
                  className={`absolute top-3 left-3 sm:top-4 sm:left-4 px-3 sm:px-4 py-1 sm:py-1.5 rounded-full text-xs sm:text-sm font-bold whitespace-nowrap ${
                    course.badge === 'Exclusivo'
                      ? 'bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900'
                      : 'bg-gradient-to-r from-emerald-500 to-cyan-500 text-white'
                  }`}
                >
                  {course.badge}
                </div>
              </div>
              <div className="p-4 sm:p-5 lg:p-6">
                <h3 className={`text-base sm:text-lg lg:text-xl font-bold mb-2 sm:mb-3 ${course.isDark ? 'text-white' : 'text-gray-900'}`}>{course.title}</h3>
                <div className={`flex items-center gap-2 ${course.isDark ? 'text-emerald-400' : 'text-emerald-600'}`}>
                  <i className="ri-play-circle-line text-lg sm:text-xl"></i>
                  <span className="text-xs sm:text-sm font-medium whitespace-nowrap">Acceso inmediato</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-center gap-3 sm:gap-4 p-4 sm:p-5 lg:p-6 rounded-xl sm:rounded-2xl bg-white shadow-md">
              <div className="w-10 h-10 sm:w-11 sm:h-11 lg:w-12 lg:h-12 rounded-lg sm:rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center flex-shrink-0">
                <i className={`${benefit.icon} text-white text-lg sm:text-xl lg:text-2xl`}></i>
              </div>
              <span className="text-sm sm:text-base text-gray-900 font-semibold">{benefit.text}</span>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 text-center">
          <p className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-2">
            Puedes acceder desde <span className="text-emerald-600">$20 De por vida</span>
          </p>
          <button
            onClick={() => {
              const checkoutSection = document.getElementById('checkout');
              if (checkoutSection) {
                checkoutSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            className="mt-4 sm:mt-6 w-full sm:w-auto px-6 sm:px-8 lg:px-10 py-3 sm:py-4 rounded-lg sm:rounded-xl font-bold text-sm sm:text-base lg:text-lg bg-gradient-to-r from-emerald-500 to-cyan-500 text-white hover:shadow-2xl hover:shadow-emerald-500/50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-block"
          >
            Ver Precio →
          </button>
        </div>
      </div>
    </section>
  );
}
